import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthenticationService } from '../../auth/authentication.service';
import { AuthenticatedUser } from '../../models/auth/authenticated-user.model';
import { SecuredSessionEncodedData } from '../../models/auth/secured-session-encoded-data.model';
import { base64toJson } from '../../util/utils';

@UntilDestroy()
@Component({
    selector: 'clfl-sso',
    templateUrl: './sso.component.html',
    styleUrls: ['./sso.component.scss']
})
export class SsoComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    ngOnInit(): void {
        this.route.data.pipe(untilDestroyed(this)).subscribe({
            next: (data: { encodedJwt: SecuredSessionEncodedData }) => {
                const returnUrl = this.route.snapshot.queryParamMap.get('route');

                const authenticatedUser = base64toJson(data.encodedJwt.jwt) as AuthenticatedUser;

                this.authenticationService.setLoggedInUser(authenticatedUser);

                this.router.navigate([`${returnUrl}`]);
            },
            error: (err) => {
                this.router.navigate(['/login']);
            }
        });
    }
}
